module.exports = __webpack_public_path__ + "img/s-4.1aced30a.svg";